/**
 * Debug logging for employer profile client-side navigation.
 * - Enabled automatically in Vite dev (`import.meta.env.DEV`).
 * - In production, run: localStorage.setItem('debug_company_profile_nav', '1') then reload.
 */
const PREFIX = '[company-profile-nav]';

export function isCompanyProfileClientNavLogEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  if (import.meta.env.DEV) return true;
  try {
    return window.localStorage?.getItem('debug_company_profile_nav') === '1';
  } catch {
    return false;
  }
}

export function logCompanyProfileClientNav(message: string, details?: Record<string, unknown>): void {
  if (!isCompanyProfileClientNavLogEnabled()) return;
  if (details !== undefined) {
    console.log(PREFIX, message, details);
  } else {
    console.log(PREFIX, message);
  }
}
